<template>
    <router-view />
</template>

<script>
export default {
    name: 'RootView',
};
</script>
